module.exports = __webpack_public_path__ + "img/gywm_tp.ed29f550.png";